// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-text-element',
    emits: ["command"],
    // #endregion
    // #region Constructor
    props: {
        schema: {
            type: Object,
            required: false,
            default: undefined,
        },
        schemaData: {
            type: Object,
            required: false,
            default: undefined,
        },
        content: {
            type: Object,
            required: false,
            default: undefined,
        },
        data: {
            type: Object,
            required: false,
            default: undefined,
        },
    },
    computed: {
        element() {
            return this.content?.element;
        },
        cssClasses() {
            if (this.element.style && this.element.style.startsWith('alert-')) {
                return "alert " + this.element.style;
            }
            else {
                return null;
            }
        }
    },
    // #endregion
});
// #endregion
